// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Avatar from 'material-ui/Avatar';
import Chip from 'material-ui/Chip';
import {CardMedia} from 'material-ui/Card';


class EditTeam extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      team_details: {
        "id": "",
        "name": "",
        "game_type": '',
        "logo": '',
        "team_members": [],
      },
      game_types: [],

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.styles = {
      chip: {
        margin: 4,
      },
      wrapper: {
        display: 'flex',
        flexWrap: 'wrap',
      },
    };
  }


  componentDidMount() {
    this.getTeamDetails();
  }

  getTeamDetails() {
     const url = `${getLocationOrigin()}/eagleeye/${this.state.id}/get_details_for_edit_team/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ game_types: data.game_type,
         team_details: data.team_details, team_players: data.team_details.team_members}))
       .catch(error => error);
  }

  postEditedTeam(data, props) {
    const url = `${getLocationOrigin()}/eagleeye/edit_team/`;
    const options = {...defaultOptions};
    var formData = new FormData();
    formData.append("id", JSON.stringify(data.id));
    formData.append("name", data.name);
    formData.append("game_type", JSON.stringify(data.game_type));
    formData.append("logo", data.logo);
    formData.append("team_members", JSON.stringify(data.team_members));
    options['method'] = 'post';
    options['body'] = formData;
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  handleFile(selectorFiles: FileList){
    var new_selected_one =  Object.assign({}, this.state.team_details);
    console.log('Fileeeee');
    console.log(selectorFiles);
    new_selected_one['logo'] = selectorFiles[0]
    this.setState({team_details: new_selected_one});
    console.log(this.state.team_details);
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.team_details);
    new_selected_one[name] = event.target.value
    console.log(new_selected_one);
    this.setState({team_details: new_selected_one});
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log('Submit');
    console.log(this.state.team_details);
    this.postEditedTeam(this.state.team_details, this.props);
    console.log('post');
    console.log(this.state);
  }

  handleRequestDelete = (key) => {
    var new_selected_one = Object.assign({}, this.state.team_details);
    console.log(new_selected_one['team_members']);
    const chipToDelete = new_selected_one['team_members'].findIndex(chip => chip.id==key);
    new_selected_one['team_members'].splice(chipToDelete, 1);
    this.setState({team_details: new_selected_one});
  };

  renderChip(data) {
    return (
      <Chip
        key={data.id}
        onRequestDelete={() => this.handleRequestDelete(data.id)}
        style={this.styles.chip}
      >
        <Avatar id={data.id} src={data.photo=='http://www.sporthood.in/assets/img/avatar.png'?data.photo:
        `https://api.sporthood.in/${data.photo}`} />
        {data.name}
      </Chip>
    );
  }

  render() {
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Edit Team</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Tournament Name
              </div>
              <input type="text"
                style={styles.input}
                name="name"
                value={this.state.team_details.name}
                onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game type
              </div>
              <select name="game_type" style={styles.item_body} className="col-md-6"
                value={this.state.team_details.game_type} onChange={this.handleChange}>
                {
                  this.state.game_types.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game + ' ' + x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Team Players
              </div>
              <div className="col-md-6" style={styles.item_body}>
                <div style={this.styles.wrapper}>
                  {this.state.team_details.team_members.map(this.renderChip, this)}
                </div>
              </div>
            </div>


            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Current logo
              </div>
              <div className="col-md-6" style={styles.input} >
                <CardMedia>
                  <img src={`https://api.sporthood.in${this.state.team_details.logo}`} alt=""/>
                </CardMedia>
              </div>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                New logo*
              </div>
              <input type="file" style={styles.input} name="logo" onChange={ (e) => this.handleFile(e.target.files) }/>
            </div>

            <div style={styles.button_submit} className="col-md-12">
              <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default EditTeam;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editTeam/index.js